/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ storeLink: NonNullable<unknown>, dec5: NonNullable<unknown>, dec12: NonNullable<unknown> }} Misc_Posts_Step1Inputs */

const id_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kunjungi ${i?.storeLink} antara ${i?.dec5} dan ${i?.dec12}.`)
};

const ms_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lawati ${i?.storeLink} antara ${i?.dec5} dan ${i?.dec12}.`)
};

const da_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Besøg ${i?.storeLink} mellem ${i?.dec5} og ${i?.dec12}.`)
};

const de_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Besuchen Sie ${i?.storeLink} zwischen dem ${i?.dec5} und dem ${i?.dec12}.`)
};

const en_us2_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visit the ${i?.storeLink} between ${i?.dec5} and ${i?.dec12}.`)
};

const es_es2_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visita la ${i?.storeLink} entre el ${i?.dec5} y el ${i?.dec12}.`)
};

const es_mx2_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visita ${i?.storeLink} entre el ${i?.dec5} y el ${i?.dec12}.`)
};

const fil_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bisitahin ang ${i?.storeLink} sa pagitan ng ${i?.dec5} at ${i?.dec12}.`)
};

const fr_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visitez le ${i?.storeLink} entre le ${i?.dec5} et le ${i?.dec12}.`)
};

const it_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visita ${i?.storeLink} tra il ${i?.dec5} e il ${i?.dec12}.`)
};

const hu_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Látogass el a ${i?.storeLink}-ra ${i?.dec5} és ${i?.dec12} között.`)
};

const nl_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bezoek de ${i?.storeLink} tussen ${i?.dec5} en ${i?.dec12}.`)
};

const no_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Besøk ${i?.storeLink} mellom ${i?.dec5} og ${i?.dec12}.`)
};

const pl_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odwiedź ${i?.storeLink} między ${i?.dec5} a ${i?.dec12}.`)
};

const pt_br2_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visite o ${i?.storeLink} entre ${i?.dec5} e ${i?.dec12}.`)
};

const pt_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visite a ${i?.storeLink} entre ${i?.dec5} e ${i?.dec12}.`)
};

const ro_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vizitează ${i?.storeLink} între ${i?.dec5} și ${i?.dec12}.`)
};

const fi_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Käy ${i?.storeLink}ssa ${i?.dec5} ja ${i?.dec12} välisenä aikana.`)
};

const sv_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Besök ${i?.storeLink} mellan ${i?.dec5} och ${i?.dec12}.`)
};

const vi_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Truy cập ${i?.storeLink} từ ${i?.dec5} đến ${i?.dec12}.`)
};

const tr_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dec5} ile ${i?.dec12} tarihleri arasında ${i?.storeLink} adresini ziyaret edin.`)
};

const cs_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Navštivte ${i?.storeLink} mezi ${i?.dec5} a ${i?.dec12}.`)
};

const bg_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посетете ${i?.storeLink} между ${i?.dec5} и ${i?.dec12}.`)
};

const ru_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посетите ${i?.storeLink} с ${i?.dec5} по ${i?.dec12}.`)
};

const uk_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Відвідайте ${i?.storeLink} з ${i?.dec5} по ${i?.dec12}.`)
};

const ar_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`قم بزيارة ${i?.storeLink} بين ${i?.dec5} و${i?.dec12}.`)
};

const hi_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.storeLink} पर ${i?.dec5} और ${i?.dec12} के बीच जाएँ।`)
};

const th_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เยี่ยมชม ${i?.storeLink} ระหว่าง ${i?.dec5} ถึง ${i?.dec12}`)
};

const ja_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dec5} から ${i?.dec12} の間に ${i?.storeLink} にアクセス。`)
};

const zh_cn2_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在 ${i?.dec5} 至 ${i?.dec12} 期间访问 ${i?.storeLink}。`)
};

const zh_hant1_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在 ${i?.dec5} 至 ${i?.dec12} 期間造訪 ${i?.storeLink}。`)
};

const ko_misc_posts_step1 = /** @type {(inputs: Misc_Posts_Step1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dec5}~${i?.dec12} 사이에 ${i?.storeLink}를 방문하세요.`)
};

/**
* | output |
* | --- |
* | "Visit the {storeLink} between {dec5} and {dec12}." |
*
* @param {Misc_Posts_Step1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_step1 = /** @type {((inputs: Misc_Posts_Step1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Step1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_step1(inputs)
	if (locale === "ms") return ms_misc_posts_step1(inputs)
	if (locale === "da") return da_misc_posts_step1(inputs)
	if (locale === "de") return de_misc_posts_step1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_step1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_step1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_step1(inputs)
	if (locale === "fil") return fil_misc_posts_step1(inputs)
	if (locale === "fr") return fr_misc_posts_step1(inputs)
	if (locale === "it") return it_misc_posts_step1(inputs)
	if (locale === "hu") return hu_misc_posts_step1(inputs)
	if (locale === "nl") return nl_misc_posts_step1(inputs)
	if (locale === "no") return no_misc_posts_step1(inputs)
	if (locale === "pl") return pl_misc_posts_step1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_step1(inputs)
	if (locale === "pt") return pt_misc_posts_step1(inputs)
	if (locale === "ro") return ro_misc_posts_step1(inputs)
	if (locale === "fi") return fi_misc_posts_step1(inputs)
	if (locale === "sv") return sv_misc_posts_step1(inputs)
	if (locale === "vi") return vi_misc_posts_step1(inputs)
	if (locale === "tr") return tr_misc_posts_step1(inputs)
	if (locale === "cs") return cs_misc_posts_step1(inputs)
	if (locale === "bg") return bg_misc_posts_step1(inputs)
	if (locale === "ru") return ru_misc_posts_step1(inputs)
	if (locale === "uk") return uk_misc_posts_step1(inputs)
	if (locale === "ar") return ar_misc_posts_step1(inputs)
	if (locale === "hi") return hi_misc_posts_step1(inputs)
	if (locale === "th") return th_misc_posts_step1(inputs)
	if (locale === "ja") return ja_misc_posts_step1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_step1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_step1(inputs)
	return ko_misc_posts_step1(inputs)
});
export { misc_posts_step1 as "misc.posts.step1" }